import { render } from "./DxtPackageTopUp.vue?vue&type=template&id=b8d2626a&scoped=true"
import script from "./DxtPackageTopUp.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUp.vue?vue&type=script&lang=js"

import "./DxtPackageTopUp.vue?vue&type=style&index=0&id=b8d2626a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8d2626a"

export default script